<template>
  <div class="header">
    <div class="header_left">
      <!-- 模块化配置logo -->
      <img v-if="logoUrl" class="configlogo" :src="logoUrl" alt="" />
      <img
        v-else
        class="logo"
        src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-main/logo.png"
      />
      <p class="separation"></p>
      <i
        :class="`iconfont ${
          isCollapse ? 'icondingbucaidanzhankai' : 'icondingbucaidanshouqi'
        } icon fl`"
        @click="setCollapse"
      ></i>
      <div
        id="branchDataBox"
        v-close
        class="branch cp"
        @click="showBranchList"
        v-if="branchList && branchList.length"
      >
        <span>
          {{ $t("MAIN_WEB_CURRENT_ORGANIZATION", { text: "当前机构：" })
          }}{{ currentBranchName || getBranchName(branch) }}
        </span>
        <i
          v-if="branchList.length > 1"
          class="el-input__icon el-icon-arrow-up"
          :style="`transform: rotate(${branchListShow ? 0 : 180}deg)`"
        ></i>
        <ul
          class="branchList"
          v-if="branchList.length > 1"
          v-show="branchListShow"
        >
          <li
            v-for="item in branchList"
            :key="item.id"
            @click="branchChange(item)"
          >
            {{ item && item.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="header_right">
      <div
        class="login-international login_right"
        v-if="isI18nFlag"
        @mouseenter="setUpLanguageEnter()"
        @mouseleave="setUpLanguageLeave()"
      >
        <!-- <img class="fl international-img" v-else-if="internationalKey == 'fr-FR'" src="../assets/images/france.png" alt="" /> -->
        <span class="fl">
          {{ $t(internationalName) }}
        </span>
        <i
          :class="`${
            setUpLanguageShow ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
          } fl international-i`"
        ></i>
        <ul
          v-show="setUpLanguageShow"
          @mouseenter="setUpLanguageEnter()"
          @mouseleave="setUpLanguageLeave()"
        >
          <li
            v-for="item in international"
            :key="item.key"
            @click="selectChange(item.key, item.val)"
            class="international-li"
          >
            <span class="international-color">{{ $t(item.val) }}</span>
          </li>
        </ul>
      </div>
      <div
        class="login_right"
        @mouseenter="setUpEnter()"
        @mouseleave="setUpLeave()"
      >
        <img class="fl cursor" src="./../assets/images/userL.png" alt="" />
        <span class="fl cursor" >
          {{ currentBranchName || getBranchName(branch) || $t("MAIN_WEB_USER", { text: '用户' }) }}
        </span>
        <i
          :class="`${
            setUpShow ? 'el-icon-caret-top cursor' : 'el-icon-caret-bottom cursor'
          } fl`"
        ></i>
        <ul
          v-show="setUpShow"
          @mouseenter="setUpEnter()"
          @mouseleave="setUpLeave()"
        >
          <li v-show="userInfo.phone">{{ userInfo.phone }}</li>
          <li>{{ userInfo.nickname }}</li>
          <li @click="toPersonal" class="cursor">个人资料</li>
          <li @click="logout" class="logout">
            {{ $t("MAIN_WEB_LOG_OUT", { text: "退出登录" }) }}
          </li>
        </ul>
      </div>
    </div>
    <el-dialog width="800px" :visible.sync="personalDialog" :append-to-body="true" :close-on-click-modal="false" center>
      <personal v-if="personalDialog"/>
    </el-dialog>
  </div>
</template>

<script>
import personal from '../views/personal/index.vue'
import conf from '../config/url.js'
// import getLanguageData from '../locale/locale'
//网站换肤功能的使用
import "mutationobserver-shim";
import actions from '../micros/actions'
import { mapState,mapMutations } from 'vuex';
const forMenu = (el, arr) => {
	const { data, children } = el
	arr = [
		...arr,
		{
			path: `/${data.systemTagName}${data.url}`,
			title: data.name,
			type: data.type,
		},
	]
	el.path = `/${data.systemTagName}${data.url}`
	el.matched = arr
	if (children && children.length) {
		children.forEach((item) => {
			forMenu(item, arr)
		})
	}
}
export default {
  props: {
    isCollapse: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      personalDialog:false,
      currentBranchName:'',
      // userInfo: {},
      setUpTimeout: null,
      branchListShow: false,
      setUpLanguageTimeout: null,
      setUpShow: false,
      setUpLanguageShow: false,
      branch: null,
      branchList: [],
      userName: "",
      logoUrl: "",
      isI18nFlag: false, //判断是否是国际化项目
      internationalName: "English",
      internationalKey: "en-US",
    };
  },
  components:{
    personal
  },
  directives: {
    close: {
      inserted(el, binding, vnode) {
        window.onclick = function (e) {
          if (!el.contains(e.target)) {
            vnode.context.branchListShow = false;
          }
        };
      },
    },
  },
  watch: {
    "$route.path": {
      handler() {
        console.log(this.branch, localStorage.getItem("branch"));
        if (localStorage.getItem("branch") != this.branch) {
          location.reload();
        }
      },
    },
  },
  computed: {
    international(){
			return [
				{key:"zh-CN",val: '中文'},//中文
				{key:"en-US",val: 'English'},//英语
				// {key:"fr-FR",val: 'MAIN_WEB_HEADER_FR'}//法语
			]
		},
    ...mapState(['userInfo'])
  },
  async created() {
    console.log('userinfo--=========',this.userInfo)
    if (localStorage.getItem("token")) {
      await this.getBranchList();
      await this.getUserInfo();
    }
    // 国际化可以切换语言
    if (localStorage.getItem("is_i18n") == "true") {
      this.isI18nFlag = true;
    } else {
      this.isI18nFlag = false;
    }

    if (localStorage.getItem("current_language")) {
      let innertational = this.international.filter(
        (item) => item.key == localStorage.getItem("current_language")
      );
      if (innertational && innertational.length > 0) {
        this.internationalName = innertational[0].val;
        this.internationalKey = innertational[0].key;
      }
    }
  },
  mounted() {
    actions.onGlobalStateChange((state,prevState)=>{
      // 主应用观察者--------
      let currentBranchName = state.currentBranchName
      if(currentBranchName){
        this.currentBranchName = currentBranchName
      }
    })
    if (localStorage.getItem("websiteLogo")) {
      this.logoUrl = localStorage.getItem("websiteLogo");
    }
  },
  methods: {
      ...mapMutations(['setUserInfo']),
      toPersonal(){
        // this.$router.push('/personal')
        this.personalDialog = true
      },
      getConfiguration() {

          let websiteLogo = localStorage.getItem('websiteLogo')||sessionStorage.getItem('websiteLogo')
          if (websiteLogo) {
                      this.logoUrl = websiteLogo
                      this.$store.commit("setLogo",websiteLogo);
                      localStorage.setItem("websiteLogo", websiteLogo);
                  }
                  /** 培训任务数据统计用到 */
          let theme = localStorage.getItem('theme')||sessionStorage.getItem('theme')
          this.$store.commit("setTheme", theme);
          localStorage.setItem("theme",theme);

          let domain = localStorage.getItem('domain')||sessionStorage.getItem('domain')
          localStorage.setItem(
                      "domain",
                       domain && JSON.stringify(domain)
                          ? JSON.stringify(domain)
                          : ""
                  );

          let frontendConfig = localStorage.getItem('frontendConfig')||sessionStorage.getItem('frontendConfig')

          localStorage.setItem(
                      "configurationConfig",
              frontendConfig && JSON.stringify(frontendConfig)
                          ? JSON.stringify(frontendConfig)
                          : ""
                  );
                  const a =JSON.parse(frontendConfig).find(
                      (item) => item.key === "is_open_platform_up_commodity"
                  );
                  if (a) {
                      localStorage.setItem("isOpenToPlateform", a.value);
                  }
                  /**  * cms 配置网页标题 */

          let pageTitle = localStorage.getItem('pageTitle')||sessionStorage.getItem('pageTitle')

          if (pageTitle) {
                      localStorage.setItem("pageTitle", pageTitle);
                  }
                  setTimeout(() => {
                      document.title =
                          (pageTitle) ||
                          this.$t(
                              "MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION",
                              { text: "共享教育资源 传承人类文明" }
                          );
                  }, 300);

      },

      // getConfiguration() {
    //   this.$api.configuration
    //     .getConfiguration(conf.confUrl)
    //     .then((res) => {
    //       if (res.data && res.data.websiteLogo) {
    //         this.logoUrl = res.data.websiteLogo;
    //         this.$store.commit("setLogo", res.data.websiteLogo);
    //         localStorage.setItem("websiteLogo", res.data.websiteLogo);
    //       }
    //       /** 培训任务数据统计用到 */
    //       this.$store.commit("setTheme", res.data.theme);
    //       localStorage.setItem("theme", res.data && res.data.theme);
    //
    //       localStorage.setItem(
    //         "domain",
    //         res.data && JSON.stringify(res.data.domain)
    //           ? JSON.stringify(res.data.domain)
    //           : ""
    //       );
    //       localStorage.setItem(
    //         "configurationConfig",
    //         res.data && JSON.stringify(res.data.frontendConfig)
    //           ? JSON.stringify(res.data.frontendConfig)
    //           : ""
    //       );
    //       const a = res.data.frontendConfig.find(
    //         (item) => item.key === "is_open_platform_up_commodity"
    //       );
    //       if (a) {
    //         localStorage.setItem("isOpenToPlateform", a.value);
    //       }
    //       /**  * cms 配置网页标题 */
    //       if (res.data.pageTitle) {
    //         localStorage.setItem("pageTitle", res.data.pageTitle);
    //       }
    //       setTimeout(() => {
    //         document.title =
    //           (res.data && res.data.pageTitle) ||
    //           this.$t(
    //             "MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION",
    //             { text: "共享教育资源 传承人类文明" }
    //           );
    //       }, 300);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       document.title = this.$t(
    //         "MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION",
    //         { text: "共享教育资源 传承人类文明" }
    //       );
    //     });
    // },
    async selectChange(key, value) {
      localStorage.setItem("current_language", key);
    //   await getLanguageData();
      this.$i18n.locale = key;
      this.internationalKey = key;
      this.internationalName = value;
      this.setUpLanguageTimeout = setTimeout(() => {
        this.setUpLanguageShow = false;
      }, 100);
      document.title = this.$t(
        "MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION",
        { text: "共享教育资源 传承人类文明" }
      );
    },
    setLogo() {},
    // 切换语言
    setUpLanguageEnter() {
      clearTimeout(this.setUpLanguageTimeout);
      this.setUpLanguageShow = true;
    },
    setUpLanguageLeave() {
      this.setUpLanguageTimeout = setTimeout(() => {
        this.setUpLanguageShow = false;
      }, 300);
    },
    // 退出
    setUpEnter() {
      clearTimeout(this.setUpTimeout);
      this.setUpShow = true;
    },
    setUpLeave() {
      this.setUpTimeout = setTimeout(() => {
        this.setUpShow = false;
      }, 300);
    },
    getUserInfo() {
      this.$api.usercenter.findUser().then((res) => {
        // this.userInfo = res.data || [];
        this.setUserInfo(res.data || {})
      });
    },
    showBranchList() {
      this.branchListShow = !this.branchListShow;
    },
    getBranchName(i) {
      let name = "";
      this.branchList.forEach((item) => {
        if (item.branch == i) {
          name = item.name;
        //   this.userName = name;
        }
      });
      this.currentBranchName = name;
      return name;
    },
    logout() {
      const currentLanguage = localStorage.getItem('current_language')
      localStorage.clear();
      this.$store.state.nav = []
      // 退出登录的时候存储一下当前语言
      localStorage.setItem('current_language',currentLanguage)
      this.$router.push("/entrance");
    },
    setCollapse() {
      this.$parent.$parent.$parent.setCollapse();
    },
    getBranchList() {
      this.branch = localStorage.getItem("branch") || null;
      this.userName = localStorage.getItem("userName") || null;
      const branchList = JSON.parse(localStorage.getItem("branchList"));
      if (branchList) {
        this.branchList = branchList.filter(
          (item) => Object.prototype.toString.call(item) === "[object Object]"
        );
      }
    },
    branchChange(branch) {
      localStorage.setItem("branch", branch.branch);
      localStorage.setItem("name", branch.name);
      localStorage.setItem("organ", branch.organ);
      localStorage.setItem("actor", branch.actor);
      branch.channel && localStorage.setItem("channel", branch.channel);
      sessionStorage.setItem("branch", branch.branch);
      sessionStorage.setItem("name", branch.name);
      sessionStorage.setItem("organ", branch.organ);
      sessionStorage.setItem("actor", branch.actor);
      branch.channel && sessionStorage.setItem("channel", branch.channel);
      if(localStorage.getItem('theme')=='renshefenguan'){
        this.getBranchName(branch.branch);
        this.updateMenu().then(()=>{
          let defaultMenu = '';
          if(this.$store.state.nav[0].children.length>0){
            defaultMenu = this.$store.state.nav[0].children[0].path
          }else{
            defaultMenu = this.$store.state.nav[0].path
          }
          window.location.replace(defaultMenu);
        })
      }else{
        setTimeout(() => {
          window.location.replace("/saas/shome/index");
        }, 500);
      }
    },
    async updateMenu(){
      await this.$api.role.getUserMenu({}).then((res) => {
        if (res.data && res.data.length) {
          res.data.forEach((item) => {
            forMenu(item, [])
          })
          this.$store.commit('setNav',res.data || [])
        }
      })
    }
  },
};
</script>
<style lang="stylus" scoped>
.cursor {
  cursor: pointer;
}

.header {
  display: flex;
  justify-content: space-between;
}

.header_left {
  display: flex;
  align-items: center;
}

.logo {
  height: 24px;
}

.configlogo {
  height: 40px;
}
.separation {
  display: inline-block;
  width: 1px;
  height: 32px;
  background-color: rgba(255, 255, 255, 0.1);
  margin-left: 20px;
}

.branch {
  width: 246px;
  height: 40px;
  position: relative;
  padding: 0 20px;
  border-radius: 4px;

  &>i {
    position: absolute;
    top: 0px;
    color: #ffffff;
    z-index: 9;
    right: 0;
  }

  span {
    position: absolute;
    width: 246px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    top: 0px;
    left: 12px;
    color: #ffffff !important;
    font-size: 14px;
    line-height: 40px;
    height: 40px;
  }

  .branchList {
    background-color: #ffffff;
    width: 100%;
    padding: 4px 0;
    max-height: 156px;
    overflow-y: auto;
    position: absolute;
    z-index: 9;
    margin-left: -20px;
    border-radius: 4px;
    top: 44px;
    box-shadow: 0px 0px 8px 2px rgba(3, 3, 3, 0.1);

    li {
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      padding: 0 0 0 16px;
      color: #333333;
      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        color: #1972FF;
        background-color: #EEF4FF;
      }
    }
  }
}

.header_right {
  display: flex;
  align-items: center;
}

.login-international {
  cursor: default;
  display: flex;
  align-items: center;

  .international-img {
    width: 24px;
    height: 16px;
    margin-top: 0px;
  }

  .international-color {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
  }

  .international-i {
    margin-top: 0px;
  }

  .international-li {
    width: 87px;
  }
}

.login_right {
  cursor: default;
  padding-right: 16px;
  height: 48px;
  position: relative;
  padding: 0 12px;
  margin-top: 4px;
  border-radius: 4px;

  img {
    width: 32px;
    height: 32px;
    margin-top: 8px;
    margin-right: 16px;
  }

  span {
    color: #ffffff;
    height: 48px;
    max-width: 112px;
    line-height: 48px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  i {
    color: #ffffff;
    margin-top: 18px;
    margin-left: 12px;
  }

  ul {
    box-shadow: 0px 0px 8px 2px rgba(3, 3, 3, 0.1);
    position: absolute;
    right: 0px;
    top: 52px;
    z-index: 9;
    display: inline-block;
    padding: 4px 0;
    border-radius: 4px;
    background-color: #fff;

    li {
      text-align: left;
      max-width: 160px;
      padding: 0 16px;
      height: 32px;
      font-size: 14px;
      line-height: 32px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .logout {
      cursor: pointer;
    }
  }
}

.icon {
  padding: 20px;
  font-size: 16px;
  color: #ffffff;
}
</style>
<style lang="stylus" scoped>
html[data-theme='red'] {
  ul .logout {
    color: #EB5461;
  }

  .branch {
    background-color: #DB4350;
  }

  .login_right :hover {
    // cursor: pointer;
  }

  .el-header {
    background-color: #EB5461 !important;
  }

  .header {
    padding: 0px 20px;
    background-color: #EB5461 !important;
  }
}

html[data-theme='init'] {
  ul .logout {
    color: #1972FF;
  }

  .branch {
    background-color: #1865E4;
  }

  .login_right :hover {
    // cursor: pointer;
  }

  .el-header {
    background-color: #1972FF !important;
  }

  .header {
    padding: 0px 20px;
    background-color: #1972FF !important;
  }
}
</style>
